"use strict";

import React from 'react';
import AccountEcheckListItem from "./AccountEcheckListItem";

const AccountEcheckList = ({echecks=[], isFetchingEchecks=false, onRevokeEcheck=()=>{},}) => {
    if(isFetchingEchecks){
        return (
            <div className="loading loading--w-flip" />
        );
    }
    if(!!echecks && echecks.length){
        return (
            <table className="table--rows-bordered echeck__echeck-table">
                <thead>
                <tr>
                    <th scope="col">&nbsp;</th>
                    <th scope="col">Account Type</th>
                    <th scope="col">Account Nick Name</th>
                    <th scope="col">Financial Inst. Name</th>
                    <th scope="col">Status</th>
                    <th scope="col">Created On</th>
                </tr>
                </thead>
                <tbody>
                {echecks.map( (echeck, i)=>
                    <AccountEcheckListItem key={`echeck-index-${i}`} echeck={echeck} onRevokeEcheck={onRevokeEcheck} />
                )}
                </tbody>
            </table>
        );
    }
    else{
        return (
            <h5>No Echecks</h5>
        );
    }

};

export default AccountEcheckList;
